import React from 'react';
import { CardData } from 'data/types/CardData';
import { CreditCardImage } from './design-system/CreditCardImage';

interface TableCardButtonProps {
  cardData: CardData;
  onClick: (event?: React.MouseEvent) => void;
  onDoubleClick?: () => void;
  style?: React.CSSProperties;
  size?: 'small' | 'medium';
}

export const TableCardButton: React.FC<TableCardButtonProps> = ({
  cardData,
  onClick,
  onDoubleClick,
  style,
  size = 'medium',
}) => {
  const imgWidth = size === 'small' ? 56 : 80;
  const imgMaxHeight = size === 'small' ? 36 : 60;
  const nameFontSize = size === 'small' ? 13 : 16;
  // Guard against undefined cardData
  if (!cardData) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          textAlign: 'left',
          flexGrow: 1,
          alignItems: 'center',
          padding: 8,
          borderRadius: '8px',
          border: 'none',
          color: '#999',
          fontStyle: 'italic',
          ...style,
        }}
      >
        Card data not available
      </div>
    );
  }

  return (
    <button
      style={{
        display: 'flex',
        flexDirection: 'row',
        textAlign: 'left',
        flexGrow: 1,
        alignItems: 'center',
        padding: 8,
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        ...style,
      }}
      onClick={(event) => onClick(event)}
      onDoubleClick={onDoubleClick}
    >
      <CreditCardImage
        imageName={cardData.imageName}
        alt={cardData.name}
        width={imgWidth}
        maxHeight={imgMaxHeight}
        style={{
          boxShadow: size === 'small' ? '0 1px 6px rgba(0,0,0,0.2)' : '0 5px 20px rgba(0, 0, 0, 0.3)',
          marginRight: 10,
          minWidth: imgWidth,
          borderRadius: size === 'small' ? 4 : undefined,
        }}
      />
      <span
        style={{
          lineHeight: 1.1,
          fontWeight: 400,
          margin: '4px 0',
          fontFamily: 'Merriweather',
          fontSize: nameFontSize,
        }}
      >
        {cardData.name}
      </span>
    </button>
  );
};
